import { render, staticRenderFns } from "./ImportFallObject.vue?vue&type=template&id=026732aa"
import script from "./ImportFallObject.vue?vue&type=script&lang=js"
export * from "./ImportFallObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports